import { createCustomEnum } from "../customEnum";

const CommissionStatusTypes = createCustomEnum({
	Unavailable: {
		value: 0,
		name: "false",
		displayName: "Unavailable",
	},
	Available: {
		value: 1,
		name: "true",
		displayName: "Available",
	},
});

export default CommissionStatusTypes;
